import React from "react";
import CandidateAvailabilityTable from "./CandidateAvailabilityTable";

export default function CandidateAvailabilityIndex() {
    return (
        <div className="p-6 max-w-7xl mx-auto">
            <h1 className="text-2xl font-bold text-[#5D1F42] mb-4">Candidate Availability</h1>
            <CandidateAvailabilityTable showFilters={true} />
        </div>
    );
}
